module.exports = __webpack_public_path__ + "static/media/Покана за свикване на редовно заседание на ОСА на _Формопласт_АД.fff9377f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Покана за свикване на редовно заседание на ОСА на _Формопласт_АД.pdf
// module id = 101
// module chunks = 0